import React, { useState, useRef } from "react";
import "../lifeoperatingsystemcss/Habits&routinetracker2.css";
import lifeoperaatingsystemData from "../components/LifeoperatingsystemData";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const HabitsRoutinetracker2 = () => {

  const [data, setData] = useState(
    lifeoperaatingsystemData.habits_routinetracker2
  );

  // =========================
  // UPDATE FUNCTIONS
  // =========================
  const toggleDay = (habitIndex, dayIndex) => {
    const updated = [...data.habits];
    updated[habitIndex].days[dayIndex] =
      updated[habitIndex].days[dayIndex] ? 0 : 1;

    setData({ ...data, habits: updated });
  };

  const updateHabitName = (index, value) => {
    const updated = [...data.habits];
    updated[index].name = value;
    setData({ ...data, habits: updated });
  };

  const updateTodayTask = (index, value) => {
    const updated = [...data.today];
    updated[index] = value;
    setData({ ...data, today: updated });
  };

  const addItem = (field, value) => {
    setData({
      ...data,
      [field]: [...data[field], value],
    });
  };

  const deleteItem = (field, index) => {
    const updated = data[field].filter((_, i) => i !== index);
    setData({
      ...data,
      [field]: updated,
    });
  };

  // =========================
  // DOWNLOAD
  // =========================
  const habitRef = useRef(null);

  const handlePhotoDownload = async () => {
    const canvas = await html2canvas(habitRef.current, { scale: 3 });
    const link = document.createElement("a");
    link.download = "Habits & Routine.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  const handlePdfDownload = async () => {
    const canvas = await html2canvas(habitRef.current, { scale: 3 });
    const pdf = new jsPDF("landscape", "px", [800, 540]);
    pdf.addImage(canvas.toDataURL(), "PNG", 0, 0, 800, 540);
    pdf.save("Habits & Routine.pdf");
  };
const total = data.habits.length * 7;

const completed = data.habits.reduce(
  (sum, h) => sum + h.days.filter(d => d === 1).length,
  0
);

const completionRate = Math.round((completed / total) * 100);
const streakData = [0,1,2,3,4,5,6].map(dayIndex => {
  let count = 0;

  data.habits.forEach(h => {
    if (h.days[dayIndex]) count++;
  });

  return count;
});
const getStartOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay(); // 0 = Sunday
  const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust to Monday
  return new Date(d.setDate(diff));
};
const getWeekDays = (startDate) => {
  const days = [];

  for (let i = 0; i < 7; i++) {
    const d = new Date(startDate);
    d.setDate(startDate.getDate() + i);

    days.push({
      label: d.toLocaleDateString("en-US", { weekday: "short" }),
      date: d.toLocaleDateString("en-US", { month: "short", day: "numeric" })
    });
  }

  return days;
};
const [selectedWeekStart, setSelectedWeekStart] = useState(getStartOfWeek(new Date()));

const weekDays = getWeekDays(selectedWeekStart);
  // =========================
  // JSX
  // =========================
  return (
    <div className="habits_app-container">
        <div className="habits_editor-container">

          {/* ================= EDITOR ================= */}
          <div className="habits_editor-sidebar">

        <h2>Wellness Tracker Editor</h2>


        <h3>Select Week</h3>
<input
  type="date"
  value={selectedWeekStart.toISOString().split("T")[0]}
  onChange={(e) =>
    setSelectedWeekStart(getStartOfWeek(new Date(e.target.value)))
  }
/>

        {/* HABITS */}
        <h3>Daily Wellness Habits</h3>

        {data.habits.map((h, i) => (
          <div key={i} className="dynamic-field">

            <input
              value={h.name}
              onChange={(e) => updateHabitName(i, e.target.value)}
            />

            <button onClick={() => deleteItem("habits", i)} className="delete-btn">
              Delete
            </button>

          </div>
        ))}

        <button onClick={() =>
          addItem("habits", { name: "New Habit", days: [0,0,0,0,0,0,0] })
        }>
          + Add Habit
        </button>

        {/* TODAY ROUTINE */}
        <h3>Today's Wellness Routine</h3>

        {data.today.map((t, i) => (
          <div key={i} className="dynamic-field">

            <input
              value={t}
              onChange={(e) => updateTodayTask(i, e.target.value)}
            />

            <button onClick={() => deleteItem("today", i)} className="delete-btn">
              Delete
            </button>

          </div>
        ))}

        <button onClick={() => addItem("today", "New Task")}>
          + Add Task
        </button>

        {/* STATS */}
        <h3>Stats</h3>


        <input
          type="number"
          value={data.bestStreak}
          onChange={(e) =>
            setData({ ...data, bestStreak: e.target.value })
          }
          placeholder="Best Streak"
        />

        {/* NOTES */}
        <h3>Notes</h3>

        <textarea
          value={data.notes}
          onChange={(e) =>
            setData({ ...data, notes: e.target.value })
          }
        />

        <button className="download-btn" onClick={handlePhotoDownload}>
            Download Image
          </button>
          <button className="download-btn" onClick={handlePdfDownload}>
            Download PDF
          </button>
        </div>

      {/* ================= PREVIEW ================= */}
      <div className="lifedashboard_editor-preview-wrapper">

        <div className="lifehabit2_pdf-page" ref={habitRef}>
          <div className="habits2_resume-content">
            <div className="dashboard">
            <h3>{}</h3>
            <div className="habit2_date-card">
  <strong>
    {weekDays[0].date} - {weekDays[6].date}
  </strong>
</div>
<div className="habit2-container">
            <table style={{marginTop:"0px",fontSize:"10px",marginLeft:"50px"}} className="habits_table">
              <thead>
                <tr className="habits_border">
                  <th className="habits_border">Habit</th>
                  {["M","T","W","T","F","S","S"].map(d => (
                    <th key={d} className="habits_border">{d}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data.habits.map((h, i) => (
                  <tr key={i} className="habits_border">
                    <td style={{fontSize:"10px"}} className="habits_border">{h.name}</td>

                    {h.days.map((d, j) => (
                      <td key={j} className="habits_border">
                        <div
                          className={d ? "dot active" : "dot"}
                          onClick={() => toggleDay(i, j)}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="stats2">
              <p style={{fontSize:"10px"}}>Completion: {completionRate}%</p>
              <p style={{fontSize:"10px"}}>Best Streak: {data.bestStreak} days</p>
              <div className="habit_display"><div className="progress-ring">
  <svg width="90" height="90">
    <circle cx="45" cy="45" r="35" className="bg"></circle>
    <circle
      cx="45"
      cy="45"
      r="35"
      className="progress"
      style={{
        strokeDasharray: 251,
        strokeDashoffset: 251 - (251 * completionRate) / 100
      }}
    ></circle>
  </svg>

  <span>{completionRate}%</span>
</div>
<div className="chart" style={{marginTop:"30px",marginLeft:"30px"}}>
  <svg viewBox="0 0 300 100">

    <polyline
      fill="none"
      stroke="#3b82f6"
      strokeWidth="3"
      points={streakData
        .map((v, i) => `${i * 40},${100 - v * 15}`)
        .join(" ")}
    />

  </svg></div>
</div></div>
            </div>
<div className="habit2-container">
            <div className="habit2_today" style={{fontSize:"10px"}}>
              <h4>✨ Today's Wellness Rituals</h4>
              {data.today.map((t, i) => (
                <label key={i} style={{fontSize:"10px"}}>
                  <input type="checkbox" /> {t}
                </label>
              ))}
            </div>

            <div className="habit2_notes">
              <h4 style={{fontSize:"10px"}}>💭 Wellness Reflection</h4>
              <p style={{color:"white",fontSize:"10px"}}>{data.notes}</p>
            </div>

          </div>
        </div>
</div>
      </div>
    </div></div></div>
  );
};

export default HabitsRoutinetracker2;